import { useQuery } from '@tanstack/react-query'

import { getPurchaseApplications } from '@src/api'
import { DefaultApiGetPurchaseApplicationsRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'
import { isPresident } from '@src/utils'

export const useFetchPurchaseApplications = (
  params: DefaultApiGetPurchaseApplicationsRequest
) => {
  const { axiosInstance } = useAxios()

  const { organizationId, ...queryParams } = params

  return useQuery({
    // In President Card, there is no purchase application function.
    enabled: !!organizationId && !isPresident(),
    queryFn: () => getPurchaseApplications(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_PURCHASE_APPLICATIONS,
      organizationId,
      queryParams,
    ],
  })
}
